export default "__VITE_ASSET__CbDuZaVp__"